/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Previous_EmptyInputs */

const en_us2_profile_editors_previous_empty = /** @type {(inputs: Profile_Editors_Previous_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First entry`)
};

const pt_br2_profile_editors_previous_empty = /** @type {(inputs: Profile_Editors_Previous_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeiro registro`)
};

const es_419_profile_editors_previous_empty = /** @type {(inputs: Profile_Editors_Previous_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primer registro`)
};

const pt_pt2_profile_editors_previous_empty = /** @type {(inputs: Profile_Editors_Previous_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeiro registo`)
};

const fr_fr2_profile_editors_previous_empty = /** @type {(inputs: Profile_Editors_Previous_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Première entrée`)
};

const de_de2_profile_editors_previous_empty = /** @type {(inputs: Profile_Editors_Previous_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erster Eintrag`)
};

const it_it2_profile_editors_previous_empty = /** @type {(inputs: Profile_Editors_Previous_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima registrazione`)
};

/**
* | output |
* | --- |
* | "First entry" |
*
* @param {Profile_Editors_Previous_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_previous_empty = /** @type {((inputs?: Profile_Editors_Previous_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Previous_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_previous_empty(inputs)
	if (locale === "es-419") return es_419_profile_editors_previous_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_previous_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_previous_empty(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_previous_empty(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_previous_empty(inputs)
	return en_us2_profile_editors_previous_empty(inputs)
});
export { profile_editors_previous_empty as "profile-editors.previous_empty" }